import { Text } from "@smoothincorg/smooth-ui"
import React from "react"
import { generateClassName } from "src/lib/utils/generate-class-name"
import * as styles from "./InputField.css"

type Props = JSX.IntrinsicElements["input"] & {
  label: string | JSX.Element
  labelStyle?: React.CSSProperties
  validationMessage?: string | React.ReactNode
}

// eslint-disable-next-line react/display-name
export const InputField = React.forwardRef<HTMLInputElement, Props>(
  (
    {
      label,
      validationMessage,
      labelStyle = {
        marginBottom: 4,
        display: "block",
      },
      style,
      className,
      ...props
    },
    ref
  ) => {
    return (
      <span
        style={
          props.disabled
            ? {
                opacity: 0.5,
                pointerEvents: "none",
                ...(style || {}),
              }
            : style
        }
        className={generateClassName("InputField", [className, styles.root])}
      >
        {typeof label === "string" ? (
          <Text size={14} color="darkBlue" style={labelStyle}>
            {label}
          </Text>
        ) : (
          label
        )}

        <input className={styles.input} {...props} ref={ref} />
        {typeof validationMessage === "string" && (
          <Text size={12} color="red" style={{ marginTop: 4 }}>
            {validationMessage}
          </Text>
        )}
        {typeof validationMessage !== "string" && validationMessage && validationMessage}
      </span>
    )
  }
)
